<template lang="pug">
  v-col(cols="12" md="3"  lg="2" sm="6" xs="12")
    v-card.elevation-8
      v-img(class="white--text align-end" height="150px" src="https://images2.minutemediacdn.com/image/upload/c_fill,w_912,h_516,f_auto,q_auto,g_auto/shape/cover/sport/france-v-germany-uefa-nations-league-a-5bca0ac66f0e5b6500000001.jpg")
      v-card-text.px-10
        p Juan Jose
        b Apuesta: 500$

</template>

<script>
  export default {
    name: "UserCard"
  }
</script>

<style lang="sass">
</style>